import { useEffect } from "react";
import { useParker } from "../../../../providers/parker";
import { usePermitFormActions } from "../../PermitContextProvider";

export const useAccountPrefill = () => {
	const { parker } = useParker();
	const { prefillAccountData } = usePermitFormActions();

	useEffect(() => {
		if (!parker) {
			return;
		}
		prefillAccountData({
			email: parker.email ?? undefined,
			vehicles: parker.defaultVehicle ? [parker.defaultVehicle] : undefined,
		});
	}, [parker, prefillAccountData]);
};
